var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"calendar-cell mx-auto",class:{
    'is-selected': _vm.selected,
    'is-disabled': !_vm.stock
  }},[_c('div',{staticClass:"calendar-cell__day"},[_vm._v(_vm._s(_vm.date.date()))]),_vm._v(" "),(_vm.stock)?[_c('div',{staticClass:"calendar-cell__stock"},[_vm._v("\n      "+_vm._s(_vm.getStockLabel(_vm.stock.lost_stock))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"calendar-cell__price whitespace-nowrap line-clamp-1"},[_vm._v("\n      ￥"+_vm._s(_vm.stock.price)+"起\n    ")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }